import apiConfig from "../ApiConfig";

/**
 * Fetch all automation compliance tasks for a customer
 * @param {string} customerId
 */
export const getAutoComplianceTasksApi = async (customerId) => {
  const res = await apiConfig.get(
    `/api/auto-compliance/tasks/?customer_id=${customerId}`
  );
  return res.data;
};

/**
 * Fetch compliance summary / score for a customer
 * @param {string} customerId
 */
export const getAutoComplianceSummaryApi = async (customerId) => {
  const res = await apiConfig.get(
    `/api/auto-compliance/summary/?customer_id=${customerId}`
  );
  return res.data;
};

/**
 * Trigger automation run for a specific task
 * @param {string} customerId
 * @param {string} taskId
 */
export const runAutoComplianceTaskApi = async (customerId, taskId) => {
  const res = await apiConfig.post(`/api/auto-compliance/tasks/${taskId}/run/`, {
    customer_id: customerId,
  });
  return res.data;
};

/**
 * Update an automation task (status, notes, etc.)
 * @param {string} taskId
 * @param {Object} payload
 */
export const updateAutoComplianceTaskApi = async (taskId, payload) => {
  const res = await apiConfig.patch(
    `/api/auto-compliance/tasks/${taskId}/`,
    payload
  );
  return res.data;
};
